import { FieldNames } from 'Src/constants/FieldNames'
import { ReserveAccountFields } from 'Pages/orders_design/constants/orderFields'

const ContactPersonDetails = [
	FieldNames.LAST_NAME,
	FieldNames.FIRST_NAME,
	FieldNames.MIDDLE_NAME,
	FieldNames.PHONE,
	FieldNames.EMAIL,
]

const Common = [
	FieldNames.REGION_ID,
	FieldNames.CITY_ID,
	FieldNames.MERCHANT_BRANCH_ID,
	FieldNames.ADD_INFO,
	FieldNames.CALL_ME,
	FieldNames.DEAL_AMOUNT,
	FieldNames.DEAL_SUBJECT_ID,
	FieldNames.NOTICE_NUMBER,
	FieldNames.RATE,
	FieldNames.ATTACHMENTS,
	FieldNames.SPECIAL_OFFER_ID,
	FieldNames.OTKRITIE_BANK_CITY,
]

const OnlineTerminalOnly = [FieldNames.EQUIP_CONNECT_TYPE, FieldNames.EQUIP_AMOUNT]
const Terminal = [FieldNames.EQUIP_TYPE, FieldNames.EQUIP_CONNECT_TYPE, FieldNames.EQUIP_AMOUNT]

const Tariff = [
	FieldNames.INSTALL_REGION_ID,
	FieldNames.MCC_GROUP_ID,
	FieldNames.MCC_CODE_ID,
	FieldNames.TURN_OVER, // unused??
]
const DecisionMakerPersonName = [
	FieldNames.DECISION_MAKER_PERSON_NAME,
	FieldNames.DECISION_MAKER_PERSON_LAST_NAME,
	FieldNames.DECISION_MAKER_PERSON_FIRST_NAME,
	FieldNames.DECISION_MAKER_PERSON_MIDDLE_NAME,
]
const Leader = [
	...DecisionMakerPersonName,
	FieldNames.DECISION_MAKER_EMAIL,
	FieldNames.DECISION_MAKER_PHONE,
	FieldNames.FINANCE_PERSON_NAME,
	FieldNames.FINANCE_PERSON_EMAIL,
]

const Organization = [
	FieldNames.ORGADDRESS,
	FieldNames.ACCOUNT_NUMBER,
	FieldNames.ACCOUNT_BANK_BIC,
	FieldNames.OPERATION_AVERAGE_SUM, // unused ??
]
const PointInstalationCommon = [
	FieldNames.POSADDRESS,
	FieldNames.POS_NAME,
	FieldNames.QUESTIONS_CONTACT_PHONE,
	FieldNames.INSTALL_DATE,
]
const ManagerName = [
	FieldNames.MANAGER_NAME,
	FieldNames.MANAGER_LAST_NAME,
	FieldNames.MANAGER_FIRST_NAME,
	FieldNames.MANAGER_MIDDLE_NAME,
]
const PointInstalationPerson = [...ManagerName, FieldNames.MANAGER_PHONE, FieldNames.MANAGER_EMAIL]
const AdditionalData = [
	...Leader,
	FieldNames.FINANCE_PERSON_NAME,
	FieldNames.FINANCE_PERSON_EMAIL,
	...ManagerName,
	FieldNames.MANAGER_PHONE,
	FieldNames.MANAGER_EMAIL,
]
const PointInstalation = [...PointInstalationPerson, ...PointInstalationCommon]

const OrgFields: FieldNames[] = [
	FieldNames.OGRN,
	FieldNames.OKOPF,
	FieldNames.OKFSMANUAL,
	FieldNames.KPP,
]

const ReserveFields: FieldNames[] = [FieldNames.CM_VISIT_FLAG, FieldNames.SBER_GEO_UNIT_CODE_NSI]
const PaperlessFelds: FieldNames[] = [
	FieldNames.REGION,
	FieldNames.CITY,
	FieldNames.DATE,
	FieldNames.TIME,
	FieldNames.ADDRESS_DADATA,
]

const ReserveAccount: ReserveAccountFields[] = [
	FieldNames.CM_VISIT_FLAG,
	FieldNames.SBER_GEO_UNIT_CODE_NSI,
]

export const GroupFields = {
	ContactPersonDetails,
	Common,
	OnlineTerminalOnly,
	Terminal,
	Tariff,
	Leader,
	Organization,
	PointInstalationCommon,
	PointInstalationPerson,
	DecisionMakerPersonName,
	ManagerName,
	AdditionalData,
	PointInstalation,
	ReserveAccount,
	OrgFields,
	ReserveFields,
	PaperlessFelds,
}
